import cl from 'classnames';
import * as React from 'react';
import { Editor, Transforms } from 'slate';
import { ReactEditor, useSlate } from 'slate-react';
import styled from 'styled-components';

import { ButtonEyeShowHide } from '../../ButtonEyeShowHide';
import { BaseOutlineParagraphProps } from '../OutlineParagraphPlugin.types';
import { defaultIsEmptyText, EditorPlaceHolder } from './EditorPlaceHolder';

const Main = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  gap: 24px;
  margin-bottom: 24px;
  &.hide {
    display: none;
  }
`;

interface OutlineParagraphIdeaContainerTitleProps extends BaseOutlineParagraphProps {}

const ButtonEye = ({ element }) => {
  const editor = useSlate();
  const path = ReactEditor.findPath(editor as any, element);
  const [parentNode, parentPath] = Editor.parent(editor, path) as [any, any[]];

  return (
    <ButtonEyeShowHide
      onMouseDown={(e) => {
        e.preventDefault();
        Transforms.setNodes(editor, { isHide: !parentNode.isHide }, { at: parentPath });
      }}
      isHide={parentNode.isHide as boolean}
    />
  );
};

export const OutlineParagraphIdeaContainerTitle = (
  props: OutlineParagraphIdeaContainerTitleProps
) => {
  const { attributes, children, element, isReadOnly } = props;
  const isEmptyText = defaultIsEmptyText(element);
  return (
    <Main
      {...attributes}
      className={cl(
        'outline-paragraph-idea-container-title-element',
        { hide: isEmptyText && isReadOnly },
        element.id
      )}
    >
      <div className="h3">
        <EditorPlaceHolder
          isEmptyText={() => {
            return defaultIsEmptyText(element);
          }}
          placeHolderText="Topic Sentence"
          isReadOnly={isReadOnly}
        >
          {children}
        </EditorPlaceHolder>
      </div>
      {!isReadOnly && <ButtonEye element={element} />}
    </Main>
  );
};
